import { Box, Typography } from "@mui/material";
import CustomProfil from "../Common/CustomProfil/CustomProfil";
import CustomToggleChipGroup from "../UIElements/CustomToggleChipGroup";
import { SyntheticEvent } from "react";
import { RolesEnum, TabMenu } from "../../types";
import {
    canShowBulkAssignedDossierBtn,
    getLayoutMainHeaderTitleByUserRole,
} from "./utils";
import CustomLink from "../UIElements/CustomLink";
import DropDown, { DropDownItem } from "../UIElements/DropDown";
import { sortAlphabetically } from "../../helpers";
import SearchBar from "../UIElements/SearchBar/SearchBar";

type DossiersLayoutHeaderProps = {
    headerTitle: string;
    numberOfDossier: number;
    setFilterActiveTab: Function;
    filterTabsMenu: TabMenu[];
    setSearchQuery: Function;
    filterActiveTab: string;
    userRoleId: number;
    openBulkAssignedDossierModal?: Function;
    establishmentGroupsOptionsOfDossiers: DropDownItem[];
    onEstablishmentGroupSelected: Function;
    establishementGroupSelected: number | null;
};

export default function DossiersLayoutHeader({
    headerTitle,
    numberOfDossier,
    filterTabsMenu,
    filterActiveTab,
    setFilterActiveTab,
    setSearchQuery,
    userRoleId,
    openBulkAssignedDossierModal,
    establishmentGroupsOptionsOfDossiers,
    onEstablishmentGroupSelected,
    establishementGroupSelected,
}: DossiersLayoutHeaderProps) {
    const dropDownOpts = establishmentGroupsOptionsOfDossiers.length
        ? [
              ...[{ id: -1, name: "--" }],
              ...sortAlphabetically(establishmentGroupsOptionsOfDossiers),
          ]
        : [];
    return (
        <Box
            sx={{
                marginLeft: "6rem",
                marginTop: "5vh",
                marginRight: "1.5rem",
                marginBottom: "2rem",
                display: "flex",
                flexDirection: "column",
                gap: "2.28rem",
                flexWrap: "wrap",
                "@media (max-width:1024px)": {
                    marginLeft: "1.5rem",
                },
            }}
        >
            <Box>
                <CustomProfil />
            </Box>

            <Box
                sx={{
                    gap: "1.5rem",
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                }}
            >
                <Box
                    sx={{
                        gap: "2rem",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        flexWrap: "wrap",
                    }}
                >
                    <Box
                        sx={{
                            gap: "1.5rem",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                        }}
                    >
                        <Box
                            sx={{
                                gap: "0.5rem",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#005499",

                                    fontFamily: "Roboto",
                                    fontSize: "1.75rem",
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    lineHeight: "normal",
                                }}
                            >
                                {getLayoutMainHeaderTitleByUserRole(userRoleId)}
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#023",

                                    fontFamily: "Roboto",
                                    fontSize: "1.125rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "1.25rem",
                                }}
                            >
                                {headerTitle}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                height: "0.125rem",
                                alignSelf: "stretch",
                                background: "#E3E6E8",
                            }}
                        ></Box>
                        <Box
                            sx={{
                                display: "flex",

                                gap: "16.6875rem",
                                justifyContent: "center",
                                alignItems: "center",
                                flexFlow: "row wrap",
                            }}
                        >
                            <CustomToggleChipGroup
                                active={filterActiveTab}
                                handleChange={(e: SyntheticEvent, value: any) =>
                                    setFilterActiveTab(value)
                                }
                                tabsMenu={filterTabsMenu}
                            />
                            
                        </Box>
                        { userRoleId != RolesEnum.CLIENT && <SearchBar setSearchQuery={setSearchQuery} />}
                    </Box>
                    {canShowBulkAssignedDossierBtn(userRoleId) &&
                    openBulkAssignedDossierModal ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "flex-end",
                                alignItems: "end",
                                alignSelf: "stretch",
                                justifyContent: "space-between",
                                // width: "100%",
                                // "@media (max-width:1024px)": {
                                //     //width: "100%",
                                //     flexDirection: "column",
                                // },
                            }}
                        >
                            <CustomLink
                                label="Affectation multiple"
                                onClick={() => {
                                    openBulkAssignedDossierModal();
                                }}
                            />
                        </Box>
                    ) : null}
                </Box>
            </Box>

            {dropDownOpts.length ? (
                <Box
                    sx={{
                        gap: "1.5rem",
                        display: "flex",
                        // height: "1.5rem",
                        justifyContent: "flex-end",

                        alignItems: "flex-start",
                        width: "20%",
                        "@media (max-width:1024px)": {
                            width: "100%",
                        },
                    }}
                >
                    <DropDown
                        items={dropDownOpts}
                        defaultValue={establishementGroupSelected ?? ""}
                        inputlabel={"Filter par réseau"}
                        onChange={async (event) => {
                            if (event.target.value) {
                                await onEstablishmentGroupSelected(
                                    event.target.value
                                );
                            }
                        }}
                        selectpx={{
                            border: "1px solid  #C8CDD0",
                            background: "#FFF",
                        }}
                    />
                </Box>
            ) : null}

            <Typography
                sx={{
                    color: "#023",

                    fontFamily: "Roboto",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                }}
            >
                {`${numberOfDossier} dossier(s)`}
            </Typography>
        </Box>
    );
}
